import { MutationHookOptions } from '@apollo/client';

import { useMutation } from '@frontend/app/hooks';
import { DELETE_MEMBER_FIELD } from '@frontend/app/queries/DeleteMemberField';
import { DeleteMemberField, DeleteMemberFieldVariables } from '@frontend/app/queries/types/DeleteMemberField';

type IOptions = MutationHookOptions<DeleteMemberField, DeleteMemberFieldVariables>;

export const useDeleteMemberField = (options: IOptions) => useMutation<DeleteMemberField, DeleteMemberFieldVariables>(DELETE_MEMBER_FIELD, options);
